export default "__VITE_ASSET__CI8dmN1d__"